import * as R from 'ramda';

export default function SelfcareFile(data) {
    let selfcareFile = data || {};
    this.id = selfcareFile.id;
    this.firstName = selfcareFile.firstName;
    this.lastName = selfcareFile.lastName;
    this.creationDate = selfcareFile.creationDate;
    this.meetingDate = selfcareFile.meetingDate;
    this.operator = selfcareFile.operator;
    this.operator = R.isNil(selfcareFile.operator) ? "" : `${selfcareFile.operator.firstName} ${selfcareFile.operator.lastName}`
    this.operatorId = R.isNil(selfcareFile.operator) ? undefined : selfcareFile.operator.id
}